import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetJobConfigDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { JobTypeObj } from '../../../common/spdCore/validation/schemas';

interface JobConfigSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const jobConfigForGrid = (jobConfig: GetJobConfigDto) => {
  return {
    key: jobConfig.id,
    values: {
      'jobConfig.systemNumber': jobConfig.systemNumber,
      type_pl: JobTypeObj[jobConfig.type],
      'jobConfig.crone': jobConfig.crone,
    },
    isInactive: !jobConfig.active,
  };
};

export const JobConfigSearch: React.FC<JobConfigSearchProps> = props => {
  const columns: GridColumn[] = [
    { header: 'Numer systemowy', property: 'jobConfig.systemNumber' },
    { header: 'Typ', property: 'type_pl' },
    { header: 'Częstotliwość', property: 'jobConfig.crone' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="jobConfig.systemNumber"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage="Brak zdefiniowanych zadań cyklicznych"
      onRowClick={props.onRowClick}
      withHistory={true}
      refresh={props.refresh}
      withFilterInColumns={false}
    />
  );
};
